module.exports = __webpack_public_path__ + "img/edit.3112b4bc.png";